import { render } from "./Checkbox.vue?vue&type=template&id=61b56ec2&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"

import "./Checkbox.vue?vue&type=style&index=0&id=61b56ec2&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-61b56ec2"

export default script